/**
 * A config containing properties for cards
 */
var CardConfigBase = /** @class */ (function () {
    function CardConfigBase() {
    }
    return CardConfigBase;
}());
export { CardConfigBase };
//# sourceMappingURL=card-config-base.js.map